<template>
  <a-html autoEnable="false">
    <div class="vr">
      <p>
        <svg style="width: 3em; height: 3em;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 35" enable-background="new 0 0 48 35" xml:space="preserve"><g id="Group_101" transform="translate(-1076 -134)"><path id="Path_25" fill="#FFFFFF" d="M1076,169h13.456l10.749-35h-10.749L1076,169z"></path> <path id="Path_26" fill="#FFFFFF" d="M1099.795,169h13.456L1124,134h-10.749L1099.795,169z"></path></g></svg>
      </p>
      <div class="vr-quote" v-html="block.field_values.html"></div>
      <div class="vr-quote-author">
        &mdash; {{ block.field_values.text }}
      </div>
    </div>
  </a-html>
<!--  -->
<!--    <a-entity-->
<!--        html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--        geometry="primitive: plane; width:0; height: 0"-->
<!--        material="visible: false; transparent: true"-->
<!--        yoga-layout-item="margin: 0; marginEdge: left; padding: 0"-->
<!--    >-->
<!--        <div class="vr vr-distance-1-5 vr-width-1-5 vr-height-auto xvr-padding">-->
<!--            <p>-->
<!--                <svg style="width: 3em; height: 3em;" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 35" enable-background="new 0 0 48 35" xml:space="preserve"><g id="Group_101" transform="translate(-1076 -134)"><path id="Path_25" fill="#FFFFFF" d="M1076,169h13.456l10.749-35h-10.749L1076,169z"></path> <path id="Path_26" fill="#FFFFFF" d="M1099.795,169h13.456L1124,134h-10.749L1099.795,169z"></path></g></svg>-->
<!--            </p>-->
<!--            <div class="vr-quote" v-html="block.field_values.html"></div>-->
<!--            <div class="vr-quote-author">-->
<!--                &mdash; {{ block.field_values.text }}-->
<!--            </div>-->
<!--        </div>-->
<!--    </a-entity>-->
</template>

<script>
export default {
    name: "Quote",
    props: ['block'],
}
</script>

<style scoped>

</style>